import { Splide } from '@splidejs/splide';

// Splide
if (document.querySelector('.splide')) {
    if (document.querySelector('.splide-full')) {
        new Splide('.splide-full', {
            perPage: 1,
            perMove: 1,
            rewind: true,
            autoHeight: true,
            // gap: '32px',
            pagination: false,
            // autoplay: true,
            interval: 3000,
            breakpoints: {
                1151: {
                    perPage: 1,
                },
            },
            classes: {
                prev: 'splide__arrow--prev',
                next: 'splide__arrow--next',
            },
        }).mount();
    }
}

// Sponsor logos slider (enabled when 7+ logos are rendered).
document.querySelectorAll('.sponsor-logos--slider').forEach((sliderEl) => {
    if (sliderEl.classList.contains('is-initialized')) {
        return;
    }

    sliderEl.classList.add('is-initialized');

    new Splide(sliderEl, {
        perPage: 6,
        perMove: 1,
        rewind: false,
        pagination: false,
        arrows: true,
        drag: true,
        gap: '1rem',
        breakpoints: {
            1024: {
                perPage: 4,
            },
            768: {
                perPage: 3,
            },
            480: {
                perPage: 2,
            },
        },
    }).mount();
});